import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  requireFeatureSignupsVisible,
  Route as pathlessAuthenticatedRoute,
} from '../../route';

// Feature-preview (pitch) page. Deliberately open to every authenticated user:
// it exists precisely for people who can't reach the real feature yet, and the
// "request access" CTA is the demand signal we're collecting.
// Gated by `hide-feature-signups` — when that kill switch is on, bounce home.
export const Route = createRoute({
  path: '/preview/workflows',
  getParentRoute: () => pathlessAuthenticatedRoute,
  staticData: {
    app: {
      access: {},
    },
  },
  component: lazyRouteComponent(
    () => import('../../feature-previews/WorkflowsPreviewPage'),
    'WorkflowsPreviewPage',
  ),
  loader: () => ({
    crumb: 'Workflows',
  }),
  beforeLoad: () => {
    requireFeatureSignupsVisible();
  },
});
